const JournalTab = {
  Animal: "animal",
  Bookings: "bookings",
  Evaluations: "evaluations",
  Pricing: "pricing",
  Images: "images",
};

type JournalTab = (typeof JournalTab)[keyof typeof JournalTab];

export default JournalTab;
